<template>
	<div id="container"></div>
</template>

<script>
export default {
//mounted() {
//  //   页面加载完,开始异步引入高德地图
//  //创建了一个回调函数,高德地图加载完毕会调用
//  window.onLoad = function () {
//    // 所有关于地图的逻辑全部都要写在这个回调里面
//    // 保证高德地图加载完毕
//    var map = new AMap.Map("container", {
//      zoom: 20, //级别
//      center: [113.3245904, 23.1066805], //中心点坐标
//      viewMode: "3D", //使用3D视图
//    });
//
//    // 创建一个 Marker 实例：
//    var marker = new AMap.Marker({
//      //position: new AMap.LngLat(116.39, 39.9), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
//      position: [113.3245904, 23.1066805], // 地理位置经纬度
//      offset: new AMap.Pixel(-100, -100), // 偏移量
//      // 可以指定图标图片地址
//      icon: "//vdata.amap.com/icons/b18/1/2.png", // 添加 Icon 图标 URL
//      // 可以自定义标记点显示的内容,允许插入html字符串
//      content: "",
//    });
//
//    // 插件的添加,第一个参数为插件名,第二个为回调函数
//    AMap.plugin("AMap.ToolBar", function () {
//      //异步加载插件
//      var toolbar = new AMap.ToolBar();
//      map.addControl(toolbar);
//    });
//    // 将创建的点标记添加到已有的地图实例：
//    map.add(marker);
//  };
//  // key是申请的值
//  var url =
//    "https://webapi.amap.com/maps?v=1.4.15&key=16a302b5bbfb4ecd11a3738d9e6b3552&callback=onLoad";
//  //创建一个 script dom元素
//  // doc需要补全document
//  var jsapi = document.createElement("script");
//  //设定script标签属性
//  jsapi.charset = "utf-8";
//  jsapi.src = url;
//  //将API文件引入页面中,加载完毕以后会调用函数
//  document.head.appendChild(jsapi);
//},
    mounted() {
    //   页面加载完,开始异步引入高德地图
    //创建了一个回调函数,高德地图加载完毕会调用
    window.onLoad = function () {
     var cluster, markers = [];

    var map = new AMap.Map("container", {
        resizeEnable: true,
        center: [105, 34],
        zoom: 4
    });
	
    for (var i = 0; i < points.length; i += 1) {
        markers.push(new AMap.Marker({
            position: points[i]['lnglat'],
            content: '<div style="background-color: hsla(180, 100%, 50%, 0.7); height: 24px; width: 24px; border: 1px solid hsl(180, 100%, 40%); border-radius: 12px; box-shadow: hsl(180, 100%, 50%) 0px 0px 1px;"></div>',
            offset: new AMap.Pixel(-15, -15)
        }))
    }

    var count = markers.length;
    var _renderClusterMarker = function (context) {
        var factor = Math.pow(context.count / count, 1 / 18);
        var div = document.createElement('div');
        var Hue = 180 - factor * 180;
        var bgColor = 'hsla(' + Hue + ',100%,50%,0.7)';
        var fontColor = 'hsla(' + Hue + ',100%,20%,1)';
        var borderColor = 'hsla(' + Hue + ',100%,40%,1)';
        var shadowColor = 'hsla(' + Hue + ',100%,50%,1)';
        div.style.backgroundColor = bgColor;
        var size = Math.round(30 + Math.pow(context.count / count, 1 / 5) * 20);
        div.style.width = div.style.height = size + 'px';
        div.style.border = 'solid 1px ' + borderColor;
        div.style.borderRadius = size / 2 + 'px';
        div.style.boxShadow = '0 0 1px ' + shadowColor;
        div.innerHTML = context.count;
        div.style.lineHeight = size + 'px';
        div.style.color = fontColor;
        div.style.fontSize = '14px';
        div.style.textAlign = 'center';
        context.marker.setOffset(new AMap.Pixel(-size / 2, -size / 2));
        context.marker.setContent(div)
    };

    addCluster(2);

    function addCluster(tag) {
        if (cluster) {
            cluster.setMap(null);
        }
        if (tag == 2) {//完全自定义
            cluster = new AMap.MarkerClusterer(map, markers, {
                gridSize: 80,
                renderClusterMarker: _renderClusterMarker
            });
        } else if (tag == 1) {//自定义图标
            var sts = [{
                url: "https://a.amap.com/jsapi_demos/static/images/blue.png",
                size: new AMap.Size(32, 32),
                offset: new AMap.Pixel(-16, -16)
            }, {
                url: "https://a.amap.com/jsapi_demos/static/images/green.png",
                size: new AMap.Size(32, 32),
                offset: new AMap.Pixel(-16, -16)
            }, {
                url: "https://a.amap.com/jsapi_demos/static/images/orange.png",
                size: new AMap.Size(36, 36),
                offset: new AMap.Pixel(-18, -18)
            }, {
                url: "https://a.amap.com/jsapi_demos/static/images/red.png",
                size: new AMap.Size(48, 48),
                offset: new AMap.Pixel(-24, -24)
            }, {
                url: "https://a.amap.com/jsapi_demos/static/images/darkRed.png",
                size: new AMap.Size(48, 48),
                offset: new AMap.Pixel(-24, -24)
            }];
            cluster = new AMap.MarkerClusterer(map, markers, {
                styles: sts,
                gridSize: 80
            });
        } else {//默认样式
            cluster = new AMap.MarkerClusterer(map, markers, {gridSize: 80});
        }
    }
    };
    // key是申请的值
    var url =
      "https://webapi.amap.com/maps?v=1.4.15&key=f3b0d3425c983ea30a3ba93111004ffb&callback=onLoad&plugin=AMap.MarkerClusterer";
    //创建一个 script dom元素
    // doc需要补全document
    var jsapi = document.createElement("script");
    //设定script标签属性
    jsapi.charset = "utf-8";
    jsapi.src = url;
    
     // key是申请的值
    var url_two =
      "//a.amap.com/jsapi_demos/static/china.js";
    //创建一个 script dom元素
    // doc需要补全document
    var jsapi_two = document.createElement("script");
    //设定script标签属性
    jsapi_two.charset = "utf-8";
    jsapi_two.src = url_two;
    //将API文件引入页面中,加载完毕以后会调用函数
   
    document.head.appendChild(jsapi_two);
    document.head.appendChild(jsapi);
  },
};
</script>

<style>
#container {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/view/admin/gaode.vue